/**
 * Custom Hook: useClickOutside
 * Detects clicks outside a specified element
 */

import { useEffect } from "react";

export const useClickOutside = (selector, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(selector)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selector, callback]);
};

export default useClickOutside;
